import { useContext, useMemo } from 'react';

import type { CreatePanel, TriggerContext } from './types';

export function useTriggerContext(panel: CreatePanel): TriggerContext {
	const { setPanel } = useContext(panel.Context);

	return useMemo(
		() => ({
			setPanel,
		}),
		[setPanel],
	);
}
